import { apiClient } from '../api-client'
import { UserSettings, User } from '@/types'

// Settings API
export const settingsApi = {
  getSettings: (): Promise<UserSettings> =>
    apiClient.get('/settings'),

  updateSettings: (data: Partial<UserSettings>): Promise<UserSettings> =>
    apiClient.put('/settings', data),

  updateProfile: (data: Partial<User>): Promise<User> =>
    apiClient.put('/settings/profile', data),

  uploadAvatar: (file: File): Promise<{ avatar: string }> =>
    apiClient.post('/settings/avatar', { file }, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
}